export function getTextFromHTML(html: string): string {
  // this is a hack because editor.getText() ignores mentions
  const div = document.createElement("div");
  div.innerHTML = html.replaceAll("</p>", "</p>\n");
  const text = div.textContent;

  return text ?? "";
}
